import type {PublicMethodUtils} from '@wix/document-services-types'
import type {StatesPublicAPI} from '@wix/document-services-public-types'
import {states, utils} from '@wix/document-services-implementation'
import type {PublicModuleDeclaration} from '../../documentServicesInitialisation'

export default function (publicMethodUtils: PublicMethodUtils): PublicModuleDeclaration<StatesPublicAPI> {
    return {
        methods: {
            components: {
                states: {
                    add: publicMethodUtils.defineDataManipulationAction(states.add, {
                        isUpdatingAnchors: utils.DONT_CARE,
                        getReturnValue: states.getStateVariantToAddRef
                    }),
                    update: publicMethodUtils.defineDataManipulationAction(states.update),
                    remove: publicMethodUtils.defineDataManipulationAction(states.remove),
                    get: publicMethodUtils.defineGetter(states.get),
                    getAll: publicMethodUtils.defineGetter(states.getAll)
                }
            }
        }
    }
}
